import { CtaBannerProps } from './CtaBanner';

export default function ParseBannerWithCta(section: any): CtaBannerProps {
  return {
    title: section?.metadata?.title,
    description: section?.metadata?.description,
    cta: section?.metadata?.ctas?.[0],
    media: section?.images?.[0],
    backgroundColor: section?.metadata?.theme?.backgroundColor,
    textColor: section?.metadata?.theme?.textColor,
    primaryColor: section?.metadata?.theme?.primaryColor,
  };
}
